import React from "react"
import classnames from "classnames"
import { Content, H4 } from "AtomicComponents"
import styles from "./HeroContent.less"
import { Image } from "AtomicContainers"
class HeroContent extends React.PureComponent {
  render() {
    const {
      imageSrc,
      heading,
      description,
      details,
      Icon= null,
      iconColor,
      textAlign='center',
      theme
    } = this.props

    return (
      <div className={classnames({
        [styles.HeroContent]: true
      })}>
        <div className={classnames({
          [styles.HeroContentImageContainer]: true
        })}>
          {imageSrc &&
            <Image
              className={classnames({
                [styles.HeroContentImage]: true
              })}
              src={imageSrc} />
          }
        </div>
        {Icon &&
          <div
            className={classnames({
              [styles.HeroContentIcon]: true,
              [styles.HeroContentIconRed]: iconColor === 'red'
            })}
          >
              <Icon />
          </div>
        }
        <div className={classnames({
          [styles.ContentArea]: true,
          [styles.Left]: textAlign==='left',
          [styles.Right]: textAlign==='right',
        })}>
          {heading &&
            <div className={classnames({
              [styles.ContentAreaHeading]: true,
              [styles.White]: theme==='dark'
            })}>
              <H4
                withDetails
                white={theme==='dark'}
              >
                {heading}
              </H4>
            </div>
          }
          {description &&
            <div
              className={classnames({
                [styles.ContentAreaContent]: true
              })}>
              <Content xmlString={description} theme={theme} textAlign={textAlign} />
            </div>
          }
          {details &&
            <span className={classnames({
              [styles.Details]: true
            })}>
              {details}
            </span>
          }
        </div>
      </div>
    )
  }
}


export default HeroContent



// WEBPACK FOOTER //
// ./src/AtomicContainers/HeroContent/HeroContent.jsx